import { IsOptional, IsNotEmpty, IsArray, ValidateNested, IsString } from 'class-validator';

/**
 * Represents a single item in the composition hierarchy.
 * The composition structure is recursive, allowing nested items.
 */
export class NomenclatureUnitCompositionRequest {
    /** Optional UUID of the child nomenclature position */
    @IsOptional()
    @IsString()
    @IsNotEmpty()
    public nomPositionChildUuid?: string | null;

    /** Optional UUID of the nomenclature position */
    @IsOptional()
    @IsString()
    public nomPositionUuid?: string | null;

    /** Optional nested composition items can be null or an array of items */
    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    public composition?: NomenclatureUnitCompositionRequest[] | null;

    constructor(data?: Partial<NomenclatureUnitCompositionRequest>) {
        this.nomPositionChildUuid = data?.nomPositionChildUuid;
        this.nomPositionUuid = data?.nomPositionUuid;
        this.composition = Array.isArray(data?.composition)
            ? data.composition.map(item => new NomenclatureUnitCompositionRequest(item))
            : data?.composition;
    }
}
